import { Component, Input } from '@angular/core';
import { FormGroup, FormControl, NgModel } from '@angular/forms';
import { ValidationMessageService } from './ValidationMessageService';
import { isNullOrUndefined } from '../objectUtils';

@Component({
    selector: 'validation-message',
    template: '{{errorMessage}}',
    host: { "class": "invalid-feedback" },
    standalone: false
})
export class ValidationMessageComponent {
  @Input() control: NgModel;
  @Input() message: string;
  constructor(private validationMessageService: ValidationMessageService) { }


  get errorMessage() {
    if (this.control != null) {
      for (let propertyName in this.control.errors) {
        if (this.control.errors.hasOwnProperty(propertyName) && this.control.touched) {
            if (!isNullOrUndefined(this.message) && this.message != '') return this.message;
          return this.validationMessageService.getValidatorErrorMessage(propertyName, this.control.errors[propertyName]);
        }
      }
      return null;
    }
    else if (!isNullOrUndefined(this.message) && this.message != '') {
      return this.message;
    } 
  }
}
